import React, { useEffect } from 'react';
import ReactGA from "react-ga4";


const GoogleAnalytics = () => {
    useEffect(() => { 
        
        ReactGA.initialize("G-FQNPJPTLJK");
     },[])
    return null;
};

export default GoogleAnalytics;